import React from 'react';
import './close-btn.styles.scss';

const CloseBtn = ({className, ...otherProps}) => (
    <span 
        aria-label="An X indicating the use of a close button" 
        className={`close-btn ${className ? className : ''}`}
    ></span>
)

export default CloseBtn;